import React from 'react';
interface SparkleProps {
  className?: string;
}
export function Sparkle({
  className = ''
}: SparkleProps) {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`text-brand-aqua ${className}`} data-id="element-5">
      <path d="M12 0C12 0 12 8.5 18.5 12C12 15.5 12 24 12 24C12 24 12 15.5 5.5 12C12 8.5 12 0 12 0Z" fill="currentColor" data-id="element-6" />
      <path d="M20.5 3C20.5 3 20.5 5.5 23 6.5C20.5 7.5 20.5 10 20.5 10C20.5 10 20.5 7.5 18 6.5C20.5 5.5 20.5 3 20.5 3Z" fill="currentColor" data-id="element-7" />
      <path d="M4.5 18C4.5 18 4.5 19.5 6 20C4.5 20.5 4.5 22 4.5 22C4.5 22 4.5 20.5 3 20C4.5 19.5 4.5 18 4.5 18Z" fill="currentColor" data-id="element-8" />
    </svg>;
}